import type { SVGProps } from "react";
import { cx } from "@/lib/cx";
import { iconPaths, type IconName } from "./icons";

export type IconProps = Omit<SVGProps<SVGSVGElement>, "name"> & {
  name?: IconName;
  size?: number;
};

/**
 * Inline SVG icon drawn with `currentColor`, so it inherits text colour and
 * participates in hover transitions like any other glyph.
 */
export function Icon({ name = "arrow-right", size = 18, className, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={cx("block flex-none", className)}
      {...rest}
    >
      {iconPaths[name]}
    </svg>
  );
}
